export const color = {
  home: {
    textDescription: '#808080',
  },
};
